/**
 * Zahlen aus Eingabefeldern lesen.
 *
 * `Number("12 V")` ist NaN, `Number("")` ist 0. Beides landete in Messwerten
 * des Prüfprotokolls und in der Neigung einer Fläche: Ein geleertes Feld hieß
 * plötzlich Flachdach, ein Messwert mit Einheit stand lokal als NaN und am
 * Server als null — und am Schirm weiter der getippte Text.
 */

export interface Zahlgrenzen {
  min?: number;
  max?: number;
  /** Nur ganze Zahlen. */
  ganz?: boolean;
}

/**
 * `undefined` heißt leer, `null` heißt ungültig. Komma und Punkt gehen beide,
 * eine angehängte Einheit nicht — lieber zurückweisen als falsch lesen.
 */
export function leseZahl(text: string, grenzen: Zahlgrenzen = {}): number | undefined | null {
  const roh = text.trim().replace(/\s/g, '').replace(',', '.');
  if (roh === '') return undefined;
  if (!/^[-+]?(\d+\.?\d*|\.\d+)$/.test(roh)) return null;
  const wert = Number(roh);
  if (!Number.isFinite(wert)) return null;
  if (grenzen.ganz && !Number.isInteger(wert)) return null;
  if (grenzen.min !== undefined && wert < grenzen.min) return null;
  if (grenzen.max !== undefined && wert > grenzen.max) return null;
  return wert;
}

/** Für die Anzeige im Feld: deutsches Komma, keine überflüssigen Stellen. */
export function zahlText(wert: number | null | undefined, stellen = 3): string {
  return wert == null || !Number.isFinite(wert) ? '' : wert.toLocaleString('de-AT', { maximumFractionDigits: stellen, useGrouping: false });
}
